import { IDateContentResponseModel } from "../../core/models";
import "./datecontent.scss";

export interface IDateContentProps {
  content: IDateContentResponseModel;
}

const DateContent = ({ content }: IDateContentProps) => {
  return (
    <section className="banner-date">
      <div className="banner-date__head">
        <div className="banner-date__head-date">
          <span>
            {content.title?.split(" ").length
              ? content.title.split(" ")[0]
              : content.title}
          </span>
          {content.title?.split(" ").length && (
            <span>{content.title.split(" ").slice(1)}</span>
          )}
        </div>
        <p className="banner-date__head-description">{content.text}</p>
      </div>
    </section>
  );
};

export default DateContent;
